import { SimpleModal } from '@sequencehq/core-components'
import { CustomerContextProvider } from 'Customer/hooks/useCustomerContext'
import { useCustomerContactsContext } from 'CustomerContacts/communication/internal/CustomerContacts.domain.context'
import {
  ContactModalForm,
  CustomerContactsRoot,
  useContactModalForm
} from 'CustomerContacts/index'
import { FC } from 'react'

type CustomerContactsContentProps = {
  customerId: string
  onClose: () => void
  onSubmit: () => Promise<void>
}

export const CustomerContactsContent = (
  props: CustomerContactsContentProps
) => {
  return (
    <CustomerContextProvider customerId={props.customerId}>
      <CustomerContactsRoot customerId={props.customerId}>
        <ContactNeededContent
          onCancel={props.onClose}
          onSubmit={() => void props.onSubmit()}
        />
      </CustomerContactsRoot>
    </CustomerContextProvider>
  )
}

const ContactNeededContent: FC<{
  onCancel: () => void
  onSubmit: () => void
}> = ({ onCancel, onSubmit }) => {
  const ctx = useCustomerContactsContext()

  const { fieldsConfig, buttonSubmit } = useContactModalForm({
    contactId: 'new',
    customerId: ctx.queries.data.customerId,
    fieldsValues: {
      ...ctx.queries.formData,
      purposes: ['BILLING'],
      notificationSubscriptions: ['BILLING']
    },
    updateFields: ctx.mutators.internal.updateForm,
    createContact: ctx.mutators.external.out.createContact,
    updateContact: ctx.mutators.external.out.updateContact
  })

  return (
    <SimpleModal
      isOpen
      data-testid="contact"
      title="Add primary billing contact"
      cancelButtonText="Cancel"
      onClose={onCancel}
      submitButtonText="Save and continue"
      onSubmit={() => {
        // The step transition (via the wrapped onSubmit) unmounts this modal
        // once the contact is created, so it must not close itself here.
        buttonSubmit.onSubmit(onSubmit)
        return false
      }}
      submitDisabled={buttonSubmit.disabled}
    >
      <ContactModalForm fieldsConfig={fieldsConfig} />
    </SimpleModal>
  )
}
